import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon, XIcon } from 'lucide-react';
const notThis = ['This is not a random collection of Tap Dance exercises.', 'This is not a basic ebook filled with definitions and theory.', 'This is not a list of steps you still have to transform into actual lessons.'];
const pillars = ['Technique', 'Curriculum', 'Rhythm', 'Musicality', 'Improvisation', 'Performance', 'Assessment', 'Lesson planning', 'Student progression'];
export function SolutionReveal() {
  return <section className="border-y border-acad-line bg-white px-4 py-20 sm:py-24" data-id="element-180" data-mp="u4e987wdq3on">
      <div className="mx-auto max-w-4xl text-center" data-id="element-181" data-mp="183m6gv8zf1q7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-182" data-mp="13zxzoes6ca60">
          <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full border border-acad-gold/60 bg-acad-goldSoft text-acad-goldDark" data-id="element-183" data-mp="2bvfn6zwgohwk">
            <LayersIcon size={25} aria-hidden="true" data-id="element-184" data-mp="2kxgi3q482rv2" />
          </span>
          <p className="mt-5 text-sm font-bold uppercase tracking-[0.15em] text-acad-gold" data-id="element-185" data-mp="2pv89mj0ygbyq">
            The complete professional system
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold leading-tight text-acad-ink sm:text-5xl" data-id="element-186" data-mp="1t6sk2mxui2lm">
            The 6-in-1 Tap Dance Teaching System for Instructors Worldwide
          </h2>
          <h3 className="mt-4 font-display text-2xl font-semibold text-acad-gold sm:text-3xl" data-id="element-187" data-mp="224cmhz7g24xt">
            Tap Dance Teacher Ready
          </h3>
          <p className="mx-auto mt-4 max-w-3xl text-base leading-7 text-acad-muted" data-id="element-188" data-mp="19hi375md5blx">
            6 Complete Volumes · 150 Ready-to-Teach Classes · 3 Visual Handbooks
            · 5 Premium Bonuses
          </p>
        </motion.div>

        <div className="mt-10 grid gap-5 text-left md:grid-cols-2" data-id="element-189" data-mp="2hq77y38gz7nz">
          <div className="space-y-4 rounded-2xl border border-acad-line bg-acad-canvas p-6" data-id="element-190" data-mp="2cse075riq5ll">
            {notThis.map(item => <div key={item} className="flex gap-3 text-sm leading-6 text-acad-muted" data-id="element-191" data-mp="2qihkvsar1r8x">
                <XIcon size={18} className="mt-0.5 shrink-0 text-acad-goldDark" aria-hidden="true" data-id="element-192" data-mp="2mk1y9pikykw1" />
                {item}
              </div>)}
          </div>
          <div className="rounded-2xl border border-acad-gold/60 bg-acad-goldSoft/60 p-6" data-id="element-193" data-mp="27tkptm7j2upn">
            <div className="flex gap-3 text-base font-medium leading-7 text-acad-ink" data-id="element-194" data-mp="22tgh4icv349z">
              <CheckIcon size={20} className="mt-1 shrink-0 text-acad-goldDark" aria-hidden="true" data-id="element-195" data-mp="3j7y6o73v69w6" />
              Tap Dance Teacher Ready is a complete 6-in-1 professional teaching
              system designed to help you know what to teach, how to progress it,
              how to correct it, how to apply it musically, and how to build
              complete classes around it.
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-2xl border border-acad-line bg-acad-canvas p-7 sm:p-9" data-id="element-196" data-mp="3hr17msvj3ysx">
          <p className="font-display text-2xl font-semibold text-acad-ink" data-id="element-197" data-mp="3hsvq80jbvetu">
            Everything works together.
          </p>
          <ul className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-198" data-mp="eau6at0l6dnb">
            {pillars.map(pillar => <li key={pillar} className="rounded-full border border-acad-gold/45 bg-white px-4 py-1.5 text-sm font-medium text-acad-ink" data-id="element-199" data-mp="3vpsi85b6n2cb">
                {pillar}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}